import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import {
  RANGE_PRESETS,
  type RangePreset,
  useOcppMessageFilters,
} from "./useOcppMessageFilters";

const { RangePicker } = DatePicker;

export const MessageRangeFilter = ({
  filters,
}: {
  filters: ReturnType<typeof useOcppMessageFilters>;
}) => (
  <>
    <Select<RangePreset | "custom">
      className="w-36"
      options={[
        ...Object.entries(RANGE_PRESETS).map(([value, { label }]) => ({
          value: value as RangePreset,
          label,
        })),
        { value: "custom", label: "Custom range", disabled: true },
      ]}
      value={filters.preset ?? "custom"}
      onChange={(preset) => {
        if (preset !== "custom") {
          filters.update({ range: preset });
        }
      }}
    />
    <RangePicker
      showTime
      value={[
        dayjs(filters.receivedRange.after),
        filters.receivedRange.before
          ? dayjs(filters.receivedRange.before)
          : null,
      ]}
      allowEmpty={[false, true]}
      onChange={(range) => {
        if (range?.[0]) {
          filters.update({
            range: {
              from: range[0].toISOString(),
              to: (range[1] ?? dayjs()).toISOString(),
            },
          });
        }
      }}
    />
  </>
);
